import './mainActions.css'


const MainActions = ({ mainActionsData }) => {

    return (
        <div className='home_action_main' >
            <a className='home_action_first_box' href='/ago/deposits'>
                <div>
                    <p>{mainActionsData?.[3]?.length || "0"}</p>
                    <div className='home_action_first_box_text'>
                        <span>Dépôts externes AGO</span>
                        <img src="/img/arrow_right.svg" alt="right arrow" />
                    </div>
                </div>
            </a>
            <a className='home_action_first_box' href="/ago/payouts">
                <div >
                    <p>{mainActionsData?.[4]?.meta?.total_count || "0"}</p>
                    <div className='home_action_first_box_text'>
                        <span>Payouts en cours AGO</span>
                        <img src="/img/arrow_right.svg" alt="right arrow" />
                    </div>
                </div>
            </a>
        </div>
    )
}

export default MainActions